import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { HttpError } from '@/api/http'

import { PostRegisterFCMTokenPayload, PostRegisterFCMTokenResponse } from './types'
import { postRegisterFCMToken } from './services'

export const useMutationPostRegisterFCMToken = (
  options?: UseMutationOptions<PostRegisterFCMTokenResponse, HttpError, PostRegisterFCMTokenPayload>
) => {
  return useMutation({ ...options, mutationFn: postRegisterFCMToken })
}
